module.exports = __webpack_public_path__ + "static/img/price-icons-rate.dc74637.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/price-icons-rate.png
// module id = d5ra
// module chunks = 215